import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';
import { AuthService } from 'src/app/common/service/AuthService';

@Component({
  selector: 'gs-header',
  templateUrl: './GSHeader.html',
  styleUrls: ['./GSHeader.scss'],
})
export class GSHeaderComponent extends AbstractComponent {
  @Output() toggleMenuSidebar: EventEmitter<any> = new EventEmitter<any>();

  public user;
  public account: any = { tenant: {} };

  @ViewChild('dropdownMenu', { static: false }) dropdownMenu;

  constructor(private service: AuthService, private renderer: Renderer2) {
    super();
  }

  public componentWillMount() {
    this.service.me().subscribe((e) => {
      this.account = e;
    });
  }
  public toggleDropdownMenu() {
    if (this.dropdownMenu.nativeElement.classList.contains('show')) {
      this.hideDropdownMenu();
    } else {
      this.showDropdownMenu();
    }
  }
  showDropdownMenu() {
    this.renderer.addClass(this.dropdownMenu.nativeElement, 'show');
  }

  hideDropdownMenu() {
    this.renderer.removeClass(this.dropdownMenu.nativeElement, 'show');
  }

  public signout() {
    this.service.logout();
  }
  
  public logout() {}
}
